import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";

export default function ProjectPhaseAccordionContextMenu({
    anchor = null,
    phase = null,
    onClose = () => { },
    menuItems = []
}) {
    const [openDialogKey, setOpenDialogKey] = useState(null);

    const handleMenuItemClick = (item) => {
        setOpenDialogKey(item.key);
    };

    const handleDialogClose = () => {
        setOpenDialogKey(null);
        onClose();
    };

    const getDialogContent = () => {
        const item = menuItems.find(m => m.key === openDialogKey);
        if (!item) return null;
        return item;
    };

    const dialogContent = getDialogContent();

    return (
        <>
            <Menu
                anchorEl={anchor}
                keepMounted
                open={Boolean(anchor)}
                onClose={onClose}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
                {menuItems.map((item) => (
                    <MenuItem
                        key={item.key}
                        onClick={() => handleMenuItemClick(item)}
                    >
                        {item.label}
                    </MenuItem>
                ))}
            </Menu>

            {openDialogKey && dialogContent && (
                <Dialog
                    open={true}
                    onClose={handleDialogClose}
                    fullWidth
                    maxWidth="sm"
                >
                    <DialogTitle>{dialogContent.title}</DialogTitle>
                    <DialogContent>
                        {React.cloneElement(dialogContent.content, { onDialogClose: handleDialogClose })}
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
}
